import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Home from './pages/Home';
import Collection from './pages/Collection';
import Login from './pages/Login';
import Holdings from './pages/Holdings';
import HoldingsSettings from './pages/HoldingsSettings';
import CryptoHoldings from './pages/CryptoHoldings';
import PrivateInvestments from './pages/PrivateInvestments';
import StockInvestments from './pages/StockInvestments';
import KanoseiIndex from './pages/KanoseiIndex';
import Transactions from './pages/Transactions';
import Notes from './pages/Notes';
import RequireAuth from './RequireAuth';

import WorkPrifmaLuminosos from './pages/CollectionItem/PrifmaLuminosos'

import WorkGoat from './pages/CollectionItem/Goat';
import WorkEardley from './pages/CollectionItem/Eardley';
import WorkRainVillage from './pages/CollectionItem/RainVillage';
import WorkElectricStorm from './pages/CollectionItem/ElectricStorm';
import WorkUniverseEdge from './pages/CollectionItem/UniverseEdge';
import WorkSkateboardRidesYou from './pages/CollectionItem/SkateboardRidesYou';

import WorkShawarma from './pages/CollectionItem/TheLastShawarma'

import WorkSeasons from './pages/CollectionItem/Seasons'
import WorkSpaceStation from './pages/CollectionItem/SpaceStation'
import WorkMartian from './pages/CollectionItem/TheMartian'
import WorkDrop from './pages/CollectionItem/TheDrop'
import WorkPsychotropic from './pages/CollectionItem/PsychotropicColony'
import WorkRaven from './pages/CollectionItem/TheRaven'
import WorkUniverseMachine from './pages/CollectionItem/TheUniverseMachine'
import WorkOnlyBeOne from './pages/CollectionItem/ThereCanOnlyBeOne'
import WorkVisualMeditation from './pages/CollectionItem/VisualMeditation'
import WorkWavestep from './pages/CollectionItem/Wavestep'
import WorkHyperreality from './pages/CollectionItem/HyperReality'
import WorkDaughter from './pages/CollectionItem/Daughter'
import WorkRabbitHole from './pages/CollectionItem/DownTheRabbitHole'
import WorkExcalibur from './pages/CollectionItem/Excalibur'

const AppRouter = () => (
        <Routes>
            {/* Header Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/collection" element={<Collection />} />

            {/* Two public pages now. /about, /contact and /investments all
                redirect rather than 404: every one of them has been linked from
                Twitter and elsewhere for years, and a dead link is a worse
                answer than the page that replaced it.

                /contact goes to the landing itself, not to an anchor — the
                reach-out form is gone, since we take no inbound, and a jump to
                a section that no longer exists would leave the reader at the
                bottom of the page wondering what they missed.

                Investments.js stays on disk, unrouted and unbundled: it holds
                the only copy of the portfolio list. */}
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<Navigate to="/" replace />} />
            <Route path="/investments" element={<Navigate to="/" replace />} />

            {/* Portfolio. Named /holdings rather than /portfolio to avoid
                reading as a sibling of the 22 /portfolio-item/* artwork routes
                below. RequireAuth only decides what renders — the data itself
                is protected by the API refusing unauthenticated requests. */}
            <Route path="/login" element={<Login />} />
            <Route
                path="/holdings"
                element={
                    <RequireAuth>
                        <Holdings />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/transactions"
                element={
                    <RequireAuth>
                        <Transactions />
                    </RequireAuth>
                }
            />
            {/* Rules moved inside the index rather than sitting beside it.
                Redirected because the standalone page was live briefly and may
                have been linked. */}
            <Route
                path="/holdings/rules"
                element={<Navigate to="/holdings/kanosei-index?view=rules" replace />}
            />
            <Route
                path="/holdings/crypto"
                element={
                    <RequireAuth>
                        <CryptoHoldings />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/stocks"
                element={
                    <RequireAuth>
                        <StockInvestments />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/private"
                element={
                    <RequireAuth>
                        <PrivateInvestments />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/notes"
                element={
                    <RequireAuth>
                        <Notes />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/kanosei-index"
                element={
                    <RequireAuth>
                        <KanoseiIndex />
                    </RequireAuth>
                }
            />
            <Route
                path="/holdings/settings"
                element={
                    <RequireAuth>
                        <HoldingsSettings />
                    </RequireAuth>
                }
            />

            {/* Collection HomePage Routes */}
            <Route path="/portfolio-item/prifma-luminosos" element={<WorkPrifmaLuminosos />} />
            <Route path="/portfolio-item/goat" element={<WorkGoat />} />
            <Route path="/portfolio-item/eardley" element={<WorkEardley />} />
            <Route path="/portfolio-item/rain-village" element={<WorkRainVillage />} />
            <Route path="/portfolio-item/an-electric-storm" element={<WorkElectricStorm />} />
            <Route path="/portfolio-item/universe-edge" element={<WorkUniverseEdge />} />
            <Route path="/portfolio-item/skateboard-rides-you" element={<WorkSkateboardRidesYou />} />
            <Route path="/portfolio-item/the-last-shawarma" element={<WorkShawarma />} />

            {/* Collection TopSlide Routes */}
            <Route path="/portfolio-item/seasons" element={<WorkSeasons />} />
            <Route path="/portfolio-item/spaceStation" element={<WorkSpaceStation />} />
            {/* The carousel links to /the-martian and /the-raven; the original
                routes were /martian and /the-Raven, so both were dead. The
                kebab-case paths are canonical now and the originals stay as
                aliases so any link already in the wild still resolves. */}
            <Route path="/portfolio-item/the-martian" element={<WorkMartian />} />
            <Route path="/portfolio-item/martian" element={<WorkMartian />} />
            <Route path="/portfolio-item/the-drop" element={<WorkDrop />} />
            <Route path="/portfolio-item/the-psychotropic-colony" element={<WorkPsychotropic />} />
            <Route path="/portfolio-item/the-raven" element={<WorkRaven />} />
            <Route path="/portfolio-item/the-Raven" element={<WorkRaven />} />
            <Route path="/portfolio-item/the-universe-machine" element={<WorkUniverseMachine />} />
            <Route path="/portfolio-item/there-can-only-be-one" element={<WorkOnlyBeOne />} />
            <Route path="/portfolio-item/visual-meditation" element={<WorkVisualMeditation />} />
            <Route path="/portfolio-item/wavestep" element={<WorkWavestep />} />
            <Route path="/portfolio-item/hyperreality" element={<WorkHyperreality />} />
            <Route path="/portfolio-item/daughter" element={<WorkDaughter />} />
            <Route path="/portfolio-item/down-the-rabbit-hole" element={<WorkRabbitHole />} />
            <Route path="/portfolio-item/excalibur" element={<WorkExcalibur />} />
        </Routes>
);

export default AppRouter;